/** The one-way lifecycle, in order: a later name is further along. */
const LIFECYCLE = ["Active", "Pseudonymized", "Anonymized", "Erased", "Deleted"];
const PSEUDONYMIZED = LIFECYCLE.indexOf("Pseudonymized");
/**
 * Mirrors OPCONF's refusal of a Pseudonymize submission: refused when the recorded state is further along, or equal
 * and complete. A state missing from LIFECYCLE is not refused: the backend stays the authority and its 409 is rendered.
 */
export function refusesPseudonymisation(current) {
    const recorded = LIFECYCLE.indexOf(current.state);
    if (recorded < 0) {
        return false;
    }
    return recorded > PSEUDONYMIZED || (recorded === PSEUDONYMIZED && !current.isPartial);
}
